export function convertIntoNumber(value) {
    return typeof value === 'string' ? Number(value) : value;
}

export const generateColors = (count) => {
    const colors = ["#FF0000", "#00FF00", "#0000FF", "#FFA500", "#800080", "#FF1493", "#1E90FF"];
    return Array.from({ length: count }, (_, i) => colors[i % colors.length]);
}

export function findStopPoints(trackingPoints) {
    let stopPoints = [];
    for (let i = 1; i < trackingPoints.length; i++) {
        const prevTimestamp = new Date(trackingPoints[i - 1].timestamp);
        const currTimestamp = new Date(trackingPoints[i].timestamp);
        const timeDiff = (currTimestamp - prevTimestamp) / (1000 * 60); // Convert ms to minutes
        if (timeDiff >= 5) {
            stopPoints.push({ device: trackingPoints[i], diff: timeDiff.toFixed(2) });
        }
    }
    return stopPoints;
}

export function findPausePoints(trackingPoints) {
    let pausePoints = [];
    for (let i = 1; i < trackingPoints.length; i++) {// Convert ms to minutes
        if (trackingPoints[i]?.status_type_id && trackingPoints[i]?.status_type_id == 30) {
            const prevTimestamp = new Date(trackingPoints[i - 1].timestamp);
            const currTimestamp = new Date(trackingPoints[i].timestamp);
            const timeDiff = (currTimestamp - prevTimestamp) / (1000 * 60); // Convert ms to minutes
            pausePoints.push({ device: trackingPoints[i], diff: timeDiff.toFixed(2) });
        }
    }
    return pausePoints;
}

export function wayPointTrack(trackingPoints) {
    let stopPoints = [];
    for (let i = 1; i < trackingPoints.length - 1; i++) {
        const device = trackingPoints[i];

        if (device?.status_type_id && device?.status_type_id != 30) {
            stopPoints.push({ device, sequence: `#${i} point` })
        }

    }
    return stopPoints;
}